import { useState } from 'react';
import CRM from '../../../services/API/CRM.js';
import Loader from '../../Tools/Loader';
import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Layout from '../../Frames/Layout'
import { Stack, IconButton, Box, Typography} from '@mui/material';
import { Close } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import Form from './Form.js';
import Activities from '../Activities/Index.js';


export default function Index(){

    const navigate = useNavigate();

    const {id} = useParams();

    const [data, setData] = useState(null);
    

    useEffect(() => {

        if(id !== 'new'){

            CRM.getProspect(id)
                .then(r => setData(r.data))
                .catch(e => console.log(e.response.data))

        }else{
            setData({
                phone: '+33',
                origin: {id: 'crm'}
            });
        } 

    }, [id])

    const handleChange = (key, val) => {
        let copy = {...data};
        copy[key] = val;
        return setData(copy);
    }

    const showActivities = data && id !== 'new';

    return <Layout tab='prospects' menu='crm'>

        <Stack spacing={3} sx={{maxWidth: 600, margin: 'auto', mt: 2, mb: 2}}>

            <Stack direction='row' justifyContent='space-between' alignItems='center'>
                        
                <Typography variant='h1'>Fiche prospect</Typography>

                <Link to='/crm/prospects'>
                    <IconButton>
                        <Close />
                    </IconButton>
                </Link>

            </Stack>

            {data && 
                <Form 
                    id={id}
                    data={data}
                    onChange={handleChange}
                    onCreate={data => navigate(`/crm/prospects/${data.id}`)}
                />
            }

        </Stack>
        

        {showActivities && 
            <Activities 
                person={{...data, id: 'prospect_' + data.id}} 
            />
        }

        {!data && <Loader />}

        <Box height={50}></Box>

    </Layout>
}

